import { Model } from "@rematch/core";
import { IReferralsPageParams } from "shared/pages/ReferralsPage";

import { IRefreshablePropSubState } from "../../model/SharedTypes";
import { StateModules } from "../types";
import { IState } from "./..";
import { referWithProps } from "./ReferralsEffetcs";

export interface IReferralsModel extends Model {
  name: StateModules;
  state: IReferralsState;
  reducers: IReferralsReducers;
  effects: IReferralsEffects;
}

export type IReferralsState = {
  memberReferral: IRefreshablePropSubState<string>;
};

export type IReferralsReducers = {
  creatingMemberApplication: (
    state: IReferralsState,
    params: {}
  ) => IReferralsState;
  createMemberApplicationSuccess: (
    state: IReferralsState,
    params: { referralPath: string }
  ) => IReferralsState;
  createMemberApplicationFailure: (
    state: IReferralsState,
    params: { error: string }
  ) => IReferralsState;
};

export type IReferralsEffects = {
  referWithProps: (params: IReferralsPageParams, state: IState) => void;
};

export type IReferralsDispatch = {
  creatingMemberApplication: () => void;
  createMemberApplicationSuccess: (params: { referralPath: string }) => void;
  createMemberApplicationFailure: (params: { error: string }) => void;

  referWithProps: (params: IReferralsPageParams) => void;
};

export const ReferralsModule: IReferralsModel = {
  name: "referrals",
  state: {
    memberReferral: { isFetching: true }
  },
  reducers: {
    creatingMemberApplication: (
      state: IReferralsState,
      params: {}
    ): IReferralsState => ({
      ...state,
      memberReferral: {
        isFetching: true,
        error: undefined
      }
    }),
    createMemberApplicationSuccess: (
      state: IReferralsState,
      params: { referralPath: string }
    ): IReferralsState => ({
      ...state,
      memberReferral: {
        isFetching: false,
        prop: params.referralPath
      }
    }),
    createMemberApplicationFailure: (
      state: IReferralsState,
      params: { error: string }
    ): IReferralsState => ({
      ...state,
      memberReferral: {
        isFetching: false,
        error: params.error
      }
    })
  },
  effects: {
    referWithProps
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/referrals/ReferralsModule.ts